module.exports = __webpack_public_path__ + "static/media/cross.ddf9bda2.svg";